import moment from 'moment';
import React, { useEffect, useState,useCallback } from 'react';
import Select from "react-select";
// import toast from "react-hot-toast";
// import ClinicReportService from '../../../services/clinicReportService';
import utils from '../../Utils/index';
import constants from '../../Utils/constants';
import strings from '../../Utils/strings';
// import Widgets from '../../Widgets/index';
import Kpi from '../../Widgets/kpi/kpi';
import "./clinicReport.css";
import "./report.css";
import { t } from '../../Utils/translate';
import clinicService from '../../Services/clinicService';
import { format } from 'date-fns';
import Widgets from '../../Widgets';
import authService from '../../Services/authService';

function DoctorOverView({doctorList}) {
    const [clinicOverViewData, setClinicOverViewData] = useState([])
    const [doctorsReport, setDoctorsReport]=useState([])
    const [defaultDoctorValue, setDefaultDoctorValue] = useState()
    const [openCustomPopup, setOpenCustomPopup] = useState(false)
    const [startDate, setStartDate] = useState('2024-01-01')
    const [endDate, setEndDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split('T')[0]; // Format as "YYYY-MM-DD"
    })
    const [modalStartDate, setModalStartDate]=useState()
    const [modalEndDate, setModalEndDate]=useState()
    const [currentDate, setCurrentDate] = useState('')
    const [currentDuration, setCurrentDuration] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isMobileView, setIsMobileView] = useState(false);
    const doctorID=defaultDoctorValue?.value
    console.log(startDate,endDate, doctorID)
    useEffect(()=>{
        if(authService.getIsDoctorLogin() === "false" && doctorID ){
            getDoctorsReport()
        }
    },[startDate, endDate, doctorID])

    useEffect(()=>{
        if(authService.getIsDoctorLogin() === "true"){
            getDoctorOverview()
        }
    },[startDate, endDate])
    const getDoctorsReport = async () => {
        try {
            setIsLoading(true); 
            const response = await clinicService.getClinicReport(startDate, endDate, doctorID);
            if (response && response.status === 'success') {
                const doctorReportData = response.data?.doctorReport;
                setDoctorsReport(doctorReportData);
            } else {
                console.warn("API response was not successful:", response);
            }
        } catch (error) {
            console.error("Error fetching doctor details:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const getDoctorOverview = async () => {
        try {
            setIsLoading(true); 
    
            const response = await clinicService.getDoctorOverview(startDate, endDate);
            if (response && response.status === 'success') {
                const clinicReportData = response.data?.doctorReport;
                setDoctorsReport(clinicReportData);
            } else {
                console.log("API response was not successful:", response);
            }
        } catch (error) {
            console.error("Error fetching clinic report:", error);
        } finally {
            setIsLoading(false); 
        }
    };
    console.log(doctorsReport)

    useEffect(() => {
        const handleResize = () => {
          setIsMobileView(window.innerWidth > 300 && window.innerWidth < 500); 
        };
       handleResize();   
        window.addEventListener("resize", handleResize);   
        return () => {
          window.removeEventListener("resize", handleResize);
        };
      }, []);
    const fetchData = useCallback(async () => {
        try {
            setIsLoading(true);
            const formattedData = ([
                {
                    fullData: doctorsReport && doctorsReport.totalAppointments && doctorsReport.totalAppointments,
                    icon: <i className="ri-parent-line"></i>,
                    cardType: utils.strings.clinicReport.totalAppointments,
                    cartTitle: t("totalAppointments"),
                    count: doctorsReport[0].totalAppointments,
                    // houseCount: formatCount(response && response.totalAppointments && response.totalAppointments[0] && response.totalAppointments[0].inHouseCallCount),
                    // callCount: formatCount(response && response.totalAppointments && response.totalAppointments[0] && response.totalAppointments[0].audioCallCount),
                    // visitCount: formatCount(response && response.totalAppointments && response.totalAppointments[0] && response.totalAppointments[0].normalCallCount),
                    // videoCount: formatCount(response && response.totalAppointments && response.totalAppointments[0] && response.totalAppointments[0].videoCallCount),
                    // slotCount: formatCount(response && response.totalAppointments && response.totalAppointments[0] && response.totalAppointments[0].pendingAppointmentCount),
                    background: '#FF4848'
                },
                {
                    fullData: doctorsReport && doctorsReport.requestedAppointments,
                    icon: <i className="ri-time-line"></i>,
                    cardType: utils.strings.clinicReport.requestedAppointments,
                    cartTitle: t("requestedAppointments"),
                    count: doctorsReport[0].waitingForClinicConfirmation,
                    // houseCount: formatCount(response && response.requestedAppointments && response.requestedAppointments[0] && response.requestedAppointments[0].inHouseCallCount),
                    // callCount: formatCount(response && response.requestedAppointments && response.requestedAppointments[0] && response.requestedAppointments[0].audioCallCount),
                    // visitCount: formatCount(response && response.requestedAppointments && response.requestedAppointments[0] && response.requestedAppointments[0].normalCallCount),
                    // videoCount: formatCount(response && response.requestedAppointments && response.requestedAppointments[0] && response.requestedAppointments[0].videoCallCount),
                    // slotCount: formatCount(response && response.requestedAppointments && response.requestedAppointments[0] && response.requestedAppointments[0].pendingAppointmentCount),
                    background: '#FAB005'
                },
                {
                    fullData: doctorsReport && doctorsReport.completedAppointments,
                    icon: <i className="ri-calendar-event-line"></i>,
                    cardType: utils.strings.clinicReport.completedAppointments,
                    cartTitle: t("completedAppointments"),
                    count:doctorsReport[0].completedCount, 
                    // houseCount: formatCount(response && response.completedAppointments && response.completedAppointments[0] && response.completedAppointments[0].inHouseCallCount),
                    // callCount: formatCount(response && response.completedAppointments && response.completedAppointments[0] && response.completedAppointments[0].audioCallCount),
                    // visitCount: formatCount(response && response.completedAppointments && response.completedAppointments[0] && response.completedAppointments[0].normalCallCount),
                    // videoCount: formatCount(response && response.completedAppointments && response.completedAppointments[0] && response.completedAppointments[0].videoCallCount),
                    // slotCount: formatCount(response && response.completedAppointments && response.completedAppointments[0] && response.completedAppointments[0].pendingAppointmentCount),
                    background: '#228BE6'
                },
                {
                    fullData: doctorsReport && doctorsReport.rejectedAppointments,
                    icon: <i className="ri-forbid-line"></i>,
                    cardType: utils.strings.clinicReport.rejectedExpiredAppointments,
                    cartTitle: t("rejectedExpiredAppointments"),
                    count: doctorsReport[0].rejectedOrExpired,
                    // houseCount: formatCount(response && response.rejectedAppointments && response.rejectedAppointments[0] && response.rejectedAppointments[0].inHouseCallCount),
                    // callCount: formatCount(response && response.rejectedAppointments && response.rejectedAppointments[0] && response.rejectedAppointments[0].audioCallCount),
                    // visitCount: formatCount(response && response.rejectedAppointments && response.rejectedAppointments[0] && response.rejectedAppointments[0].normalCallCount),
                    // videoCount: formatCount(response && response.rejectedAppointments && response.rejectedAppointments[0] && response.rejectedAppointments[0].videoCallCount),
                    // slotCount: formatCount(response && response.rejectedAppointments && response.rejectedAppointments[0] && response.rejectedAppointments[0].pendingAppointmentCount),
                    background: '#E03131'
                },
                {
                    fullData: doctorsReport && doctorsReport.totalRevenue,
                    icon: <i className="ri-vip-diamond-line"></i>,
                    cardType: utils.strings.clinicReport.revenue,
                    cartTitle: t("revenue"),
                    count:doctorsReport[0].completedAppointments.revenue,
                    // callCount: formatCount(response && response.totalRevenue && response.totalRevenue[0] && response.totalRevenue[0].audioCallCount),
                    // visitCount: formatCount(response && response.totalRevenue && response.totalRevenue[0] && response.totalRevenue[0].normalCallCount),
                    // videoCount: formatCount(response && response.totalRevenue && response.totalRevenue[0] && response.totalRevenue[0].videoCallCount),
                    // slotCount: formatCount(response && response.totalRevenue && response.totalRevenue[0] && response.totalRevenue[0].pendingAppointmentCount),
                    background: '#37B24D',
                    currencySymbol: doctorsReport[0]?.completedAppointments?.currencySymbol || ""
                },
            ]);

            setClinicOverViewData(formattedData);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching clinic overview data:', error);
            setIsLoading(false);
        }
    }, [doctorsReport, doctorID]);
    useEffect(() => {
        if(doctorsReport){
            fetchData();
        }
    }, [doctorsReport, doctorID]);

    function formatCount(n) {
        if (n < 1e3) {
            return n
        } else if (n >= 1e3 && n < 1e6) {
            return + (n / 1e3).toFixed(1) + utils.strings.clinicReport.thousand
        } else if (n >= 1e6 && n < 1e9) {
            return + (n / 1e6).toFixed(1) + utils.strings.clinicReport.million
        } else if (n >= 1e9 && n < 1e12) {
            return + (n / 1e9).toFixed(1) + utils.strings.clinicReport.billion
        }
    }
    const handleChange = (e) => {
        if (e.value === 'Custom') {
            setOpenCustomPopup(true);
        } else {
            setCurrentDuration(e);
            clinicOverView(e.value);
        }
    };
    const clinicOverView = (value) => {
        let startDate, endDate;
        const currentDate = new Date();
        
        if (value === 'Year') {
            startDate = new Date(currentDate.getFullYear(), 0, 1); // January 1st of the current year
            endDate = currentDate; // Current date
        } else if (value === 'Month') {
            startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // First day of the current month
            endDate = currentDate; // Current date
        } else if (value === 'Week') {
            const dayOfWeek = currentDate.getDay();
            const monday = new Date(currentDate);
            monday.setDate(currentDate.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1)); // Get the previous Monday
            startDate = monday; // Start of the current week
            endDate = currentDate; // Current date
        }

        // Format dates as 'YYYY-MM-DD'
        const formattedStartDate = format(startDate, 'yyyy-MM-dd');
        const formattedEndDate = format(endDate, 'yyyy-MM-dd');
        setStartDate(formattedStartDate);
        setEndDate(formattedEndDate)
        console.log(`Start Date: ${formattedStartDate}, End Date: ${formattedEndDate}`);
        // Continue with your logic for the overview with the formatted dates...
    };
    useEffect(() => {
        if (doctorOptions.length > 0) {
            setDefaultDoctorValue(doctorOptions[0]);
        }
    }, [doctorList]);
    function renderDurationView() {
        return (
            <React.Fragment>
                <div>
                    <span>{t('selectDuration')}</span>
                </div>
                <div className="custom-calendar-input-view">
                    <div className='d-flex align-items-center mt-2'>
                        <span className='me-2'>{t('labelFrom')}</span>
                        <input type="date"
                            className='form-control generate-text'
                            min={moment().subtract(365, "days").format("YYYY-MM-DD")}
                            max={moment().format("YYYY-MM-DD")}
                            value={modalStartDate}
                            onChange={(e) => {
                                // setStartDate(e.target.value)
                                setModalStartDate(e.target.value)
                                console.log(e.target.value)
                            }}
                        />
                    </div>
                    <div className='d-flex align-items-center mt-2'>
                        <span className='mx-3'>{t('labelTo')}</span>
                        <input type="date"
                            className='form-control generate-text'
                            min={modalStartDate || moment().subtract(365, "days").format("YYYY-MM-DD")}
                            max={moment().format("YYYY-MM-DD")}
                            value={modalEndDate}
                            onChange={(e) => {
                                // setEndDate(e.target.value)
                                setModalEndDate(e.target.value)
                                console.log(e.target.value)
                            }}

                        />
                    </div>
                </div>
            </React.Fragment>
        )
    }
    function doctorHandler(e) {
        setDefaultDoctorValue(e)
        setCurrentDuration(constants.clinicReportFilterTime[0])
    }

    const doctorOptions = doctorList.map(doctor => ({
        value: doctor._id,  
        label: doctor.name,  
    }));

    return (
        <>
            {isLoading ? <Widgets.CircularLoader /> : null}
            {isMobileView ? (
                <div className='col-lg-12 mb-2 custom-padding'>
                <div className='d-flex justify-content-between align-items-center '>
                    <div className='report-sub-titles'>
                        {t('doctorOverview') }
                        </div>                 
                </div>
                <div className='horizontal-flex'>
                <div className='d-flex marginleft'>
                        <div className='doctor-dropdown me-3'>
                            {authService.getIsDoctorLogin() == "false" && 
                            <Select
                                options={doctorOptions}
                                isSearchable={false}
                                value={defaultDoctorValue}
                                styles={utils.appStyles.reportDropDowntwo}
                                onChange={doctorHandler}
                             />
                              }
                        </div>                    
                    </div>
                <div className='mobile-year'>
                            <Select
                                options={constants.clinicReportFilterTime}
                                value={currentDuration}
                                onChange={handleChange}
                                isSearchable={false}
                                placeholder={t('currentYear')}
                                styles={utils.appStyles.reportDropDown}
                            />
                        </div>
                        </div>
            </div>)
            :(           
            <div className='col-lg-12 mb-2 custom-padding'>
                <div className='d-flex justify-content-between align-items-center '>
                    <div className='report-sub-titles'>
                        {t('doctorOverview') }
                        </div>
                    <div className='d-flex'>
                        <div className='doctor-dropdown me-3'>
                            {authService.getIsDoctorLogin() == "false" && 
                            <Select
                                options={doctorOptions}
                                isSearchable={false}
                                value={defaultDoctorValue}
                                styles={utils.appStyles.reportDropDown}
                                onChange={doctorHandler}
                             />
                              }
                        </div>

                        <div>
                            <Select
                                options={constants.clinicReportFilterTime}
                                value={currentDuration}
                                onChange={handleChange}
                                isSearchable={false}
                                placeholder={t('currentYear')}
                                styles={utils.appStyles.reportDropDown}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )}
            <div className='cards-parent-imp'>
                {
                    clinicOverViewData && clinicOverViewData.map((item) => {
                        return (
                            <Kpi cardData={item} />
                        )
                    })
                }
            </div>
            {openCustomPopup ?
                <Widgets.AppDialog
                    widthType={utils.constants.dialogWidthType.regular}
                    setVisibility={(e) => {
                        setOpenCustomPopup(e);
                    }}
                    dialogTitle={t('customDuration')}
                    view={renderDurationView()}
                    dialogPositiveBtnText={t('confirm')}
                    dialogPositiveBtnCall={() => {
                        if(modalStartDate || modalEndDate){
                            setStartDate(modalStartDate)
                            setEndDate(modalEndDate)
                        }
                        setOpenCustomPopup(false)
                        setCurrentDuration(constants.clinicReportFilterTime[3])

                    }}
                /> : null}
        </>
    )
}

export default DoctorOverView